import script from "./BaseCopyButton.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseCopyButton.vue?vue&type=script&setup=true&lang=js"

import "./BaseCopyButton.vue?vue&type=style&index=0&id=46e7dd01&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46e7dd01"]])

export default __exports__